// Canonical MetaHuman 188-control ordering - the output space of arkitToMh
// (./arkitToMh.js writes indices into THIS ordering). Vendored from
// aos-facerigmatcher/facerigmatcher/common/rig_names_mh.json; previously at
// tools/data/rig_names_mh.json (build-time only). It lives under src/ so the
// runtime can derive a per-character ARKit gather from a bundle's
// rig_names.json (rigGatherFromNames.js) - the Docker build context copies
// src/ but not tools/.
export const MH_RIG_NAMES = [
  "CTRL_C_eye.translateX",
  "CTRL_C_eye.translateY",
  "CTRL_C_eye_parallelLook.translateY",
  "CTRL_C_eyesAim.translateX",
  "CTRL_C_eyesAim.translateY",
  "CTRL_C_jaw.translateX",
  "CTRL_C_jaw.translateY",
  "CTRL_C_jaw_fwdBack.translateY",
  "CTRL_C_jaw_openExtreme.translateY",
  "CTRL_C_mouth.translateX",
  "CTRL_C_mouth.translateY",
  "CTRL_C_mouth_lipShiftD.translateY",
  "CTRL_C_mouth_lipShiftU.translateY",
  "CTRL_C_mouth_stickyD.translateY",
  "CTRL_C_mouth_stickyU.translateY",
  "CTRL_C_neck_swallow.translateY",
  "CTRL_C_teethD.translateX",
  "CTRL_C_teethD.translateY",
  "CTRL_C_teethU.translateX",
  "CTRL_C_teethU.translateY",
  "CTRL_C_teeth_fwdBackD.translateY",
  "CTRL_C_teeth_fwdBackU.translateY",
  "CTRL_C_tongue_bendTwist.translateX",
  "CTRL_C_tongue_bendTwist.translateY",
  "CTRL_C_tongue_inOut.translateY",
  "CTRL_C_tongue_move.translateX",
  "CTRL_C_tongue_move.translateY",
  "CTRL_C_tongue_press.translateY",
  "CTRL_C_tongue_roll.translateY",
  "CTRL_C_tongue_thickThin.translateY",
  "CTRL_C_tongue_tipMove.translateX",
  "CTRL_C_tongue_tipMove.translateY",
  "CTRL_C_tongue_wideNarrow.translateY",
  "CTRL_L_brow_down.translateY",
  "CTRL_L_brow_lateral.translateY",
  "CTRL_L_brow_raiseIn.translateY",
  "CTRL_L_brow_raiseOut.translateY",
  "CTRL_L_ear_up.translateY",
  "CTRL_L_eye.translateX",
  "CTRL_L_eye.translateY",
  "CTRL_L_eyeAim.translateX",
  "CTRL_L_eyeAim.translateY",
  "CTRL_L_eye_blink.translateY",
  "CTRL_L_eye_cheekRaise.translateY",
  "CTRL_L_eye_eyelidD.translateY",
  "CTRL_L_eye_eyelidU.translateY",
  "CTRL_L_eye_faceScrunch.translateY",
  "CTRL_L_eye_lidPress.translateY",
  "CTRL_L_eye_pupil.translateY",
  "CTRL_L_eye_squintInner.translateY",
  "CTRL_L_eyelashes_tweakerIn.translateY",
  "CTRL_L_eyelashes_tweakerOut.translateY",
  "CTRL_L_jaw_ChinRaiseD.translateY",
  "CTRL_L_jaw_ChinRaiseU.translateY",
  "CTRL_L_jaw_chinCompress.translateY",
  "CTRL_L_jaw_clench.translateY",
  "CTRL_L_mouth_corner.translateX",
  "CTRL_L_mouth_corner.translateY",
  "CTRL_L_mouth_cornerDepress.translateY",
  "CTRL_L_mouth_cornerPull.translateY",
  "CTRL_L_mouth_cornerSharpnessD.translateY",
  "CTRL_L_mouth_cornerSharpnessU.translateY",
  "CTRL_L_mouth_dimple.translateY",
  "CTRL_L_mouth_funnelD.translateY",
  "CTRL_L_mouth_funnelU.translateY",
  "CTRL_L_mouth_lipBiteD.translateY",
  "CTRL_L_mouth_lipBiteU.translateY",
  "CTRL_L_mouth_lipSticky.translateY",
  "CTRL_L_mouth_lipsBlow.translateY",
  "CTRL_L_mouth_lipsPressD.translateY",
  "CTRL_L_mouth_lipsPressU.translateY",
  "CTRL_L_mouth_lipsRollD.translateY",
  "CTRL_L_mouth_lipsRollU.translateY",
  "CTRL_L_mouth_lipsTogetherD.translateY",
  "CTRL_L_mouth_lipsTogetherU.translateY",
  "CTRL_L_mouth_lipsTowardsTeethD.translateY",
  "CTRL_L_mouth_lipsTowardsTeethU.translateY",
  "CTRL_L_mouth_lowerLipDepress.translateY",
  "CTRL_L_mouth_pressD.translateY",
  "CTRL_L_mouth_pressU.translateY",
  "CTRL_L_mouth_purseD.translateY",
  "CTRL_L_mouth_purseU.translateY",
  "CTRL_L_mouth_pushPullD.translateY",
  "CTRL_L_mouth_pushPullU.translateY",
  "CTRL_L_mouth_sharpCornerPull.translateY",
  "CTRL_L_mouth_stickyInnerD.translateY",
  "CTRL_L_mouth_stickyInnerU.translateY",
  "CTRL_L_mouth_stickyOuterD.translateY",
  "CTRL_L_mouth_stickyOuterU.translateY",
  "CTRL_L_mouth_stretch.translateY",
  "CTRL_L_mouth_stretchLipsClose.translateY",
  "CTRL_L_mouth_suckBlow.translateY",
  "CTRL_L_mouth_thicknessD.translateY",
  "CTRL_L_mouth_thicknessInwardD.translateY",
  "CTRL_L_mouth_thicknessInwardU.translateY",
  "CTRL_L_mouth_thicknessU.translateY",
  "CTRL_L_mouth_tightenD.translateY",
  "CTRL_L_mouth_tightenU.translateY",
  "CTRL_L_mouth_towardsD.translateY",
  "CTRL_L_mouth_towardsU.translateY",
  "CTRL_L_mouth_upperLipRaise.translateY",
  "CTRL_L_neck_mastoidContract.translateY",
  "CTRL_L_neck_stretch.translateY",
  "CTRL_L_nose.translateX",
  "CTRL_L_nose.translateY",
  "CTRL_L_nose_nasolabialDeepen.translateY",
  "CTRL_L_nose_wrinkleUpper.translateY",
  "CTRL_R_brow_down.translateY",
  "CTRL_R_brow_lateral.translateY",
  "CTRL_R_brow_raiseIn.translateY",
  "CTRL_R_brow_raiseOut.translateY",
  "CTRL_R_ear_up.translateY",
  "CTRL_R_eye.translateX",
  "CTRL_R_eye.translateY",
  "CTRL_R_eyeAim.translateX",
  "CTRL_R_eyeAim.translateY",
  "CTRL_R_eye_blink.translateY",
  "CTRL_R_eye_cheekRaise.translateY",
  "CTRL_R_eye_eyelidD.translateY",
  "CTRL_R_eye_eyelidU.translateY",
  "CTRL_R_eye_faceScrunch.translateY",
  "CTRL_R_eye_lidPress.translateY",
  "CTRL_R_eye_pupil.translateY",
  "CTRL_R_eye_squintInner.translateY",
  "CTRL_R_eyelashes_tweakerIn.translateY",
  "CTRL_R_eyelashes_tweakerOut.translateY",
  "CTRL_R_jaw_ChinRaiseD.translateY",
  "CTRL_R_jaw_ChinRaiseU.translateY",
  "CTRL_R_jaw_chinCompress.translateY",
  "CTRL_R_jaw_clench.translateY",
  "CTRL_R_mouth_corner.translateX",
  "CTRL_R_mouth_corner.translateY",
  "CTRL_R_mouth_cornerDepress.translateY",
  "CTRL_R_mouth_cornerPull.translateY",
  "CTRL_R_mouth_cornerSharpnessD.translateY",
  "CTRL_R_mouth_cornerSharpnessU.translateY",
  "CTRL_R_mouth_dimple.translateY",
  "CTRL_R_mouth_funnelD.translateY",
  "CTRL_R_mouth_funnelU.translateY",
  "CTRL_R_mouth_lipBiteD.translateY",
  "CTRL_R_mouth_lipBiteU.translateY",
  "CTRL_R_mouth_lipSticky.translateY",
  "CTRL_R_mouth_lipsBlow.translateY",
  "CTRL_R_mouth_lipsPressD.translateY",
  "CTRL_R_mouth_lipsPressU.translateY",
  "CTRL_R_mouth_lipsRollD.translateY",
  "CTRL_R_mouth_lipsRollU.translateY",
  "CTRL_R_mouth_lipsTogetherD.translateY",
  "CTRL_R_mouth_lipsTogetherU.translateY",
  "CTRL_R_mouth_lipsTowardsTeethD.translateY",
  "CTRL_R_mouth_lipsTowardsTeethU.translateY",
  "CTRL_R_mouth_lowerLipDepress.translateY",
  "CTRL_R_mouth_pressD.translateY",
  "CTRL_R_mouth_pressU.translateY",
  "CTRL_R_mouth_purseD.translateY",
  "CTRL_R_mouth_purseU.translateY",
  "CTRL_R_mouth_pushPullD.translateY",
  "CTRL_R_mouth_pushPullU.translateY",
  "CTRL_R_mouth_sharpCornerPull.translateY",
  "CTRL_R_mouth_stickyInnerD.translateY",
  "CTRL_R_mouth_stickyInnerU.translateY",
  "CTRL_R_mouth_stickyOuterD.translateY",
  "CTRL_R_mouth_stickyOuterU.translateY",
  "CTRL_R_mouth_stretch.translateY",
  "CTRL_R_mouth_stretchLipsClose.translateY",
  "CTRL_R_mouth_suckBlow.translateY",
  "CTRL_R_mouth_thicknessD.translateY",
  "CTRL_R_mouth_thicknessInwardD.translateY",
  "CTRL_R_mouth_thicknessInwardU.translateY",
  "CTRL_R_mouth_thicknessU.translateY",
  "CTRL_R_mouth_tightenD.translateY",
  "CTRL_R_mouth_tightenU.translateY",
  "CTRL_R_mouth_towardsD.translateY",
  "CTRL_R_mouth_towardsU.translateY",
  "CTRL_R_mouth_upperLipRaise.translateY",
  "CTRL_R_neck_mastoidContract.translateY",
  "CTRL_R_neck_stretch.translateY",
  "CTRL_R_nose.translateX",
  "CTRL_R_nose.translateY",
  "CTRL_R_nose_nasolabialDeepen.translateY",
  "CTRL_R_nose_wrinkleUpper.translateY",
  "CTRL_convergenceSwitch.translateY",
  "CTRL_eyesAimFollowHead.translateY",
  "CTRL_faceGUIfollowHead.translateY",
  "CTRL_lookAtSwitch.translateY",
  "CTRL_neck_digastricUpDown.translateY",
  "CTRL_neck_throatExhaleInhale.translateY",
  "CTRL_neck_throatUpDown.translateY",
]
